import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=d1bfdb08&"
import script from "./queue.vue?vue&type=script&lang=tsx&"
export * from "./queue.vue?vue&type=script&lang=tsx&"
import style0 from "./queue.vue?vue&type=style&index=0&id=d1bfdb08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports